import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AdminTemplateComponent} from './admin-template/admin-template.component'
import { AdminComponent } from './admin.component';
import {AdminBotComponent} from './admin-bot/admin-bot.component'
import { SocialHubMain } from './social-hub/social-hub-main.component';
import { PipeModule } from '../pipes/pipe/pipe.module';
import {MerchantDashboardComponent} from './merchant-dashboard/merchant-dashboard.component'
import { CompetitionInfo } from './social-hub/competition-info/competition-info.component';
import { CompetitionEntry } from './social-hub/competition-entry/competition-entry.component';
import { CreateCompetition } from './social-hub/create-competition/create-competition.component'; 
import { PostHub } from './social-hub/post-hub/post-hub.component';
import { CreatePost } from './social-hub/create-post/create-post.component';
import { PostDetail } from './social-hub/post-detail/post-detail.component';
import { ListBanner } from './create-miniapps/list-banner/list-banner';
import { CreateBanner } from './create-miniapps/create-banner/create-banner';
import { BannerList } from './banner-hub/banner-list/banner.list.component';
import { BannerCreate } from './banner-hub/banner-create/banner.create.component';
import { UnsavedChangesGuard } from './social-hub/unsaved-changes-guard';
// const routes: Routes = [

//   {
//     path: 'admin',
//     children: [
//       {
//         path: '',
//         component: AdminComponent,
//       },
//       {
//         path: 'login',
//         component: AdminLoginComponent,
//       },
//     ],
//   },
  

const routes: Routes = [
  { path: '', component: AdminComponent},
  { path: 'template/:merchantId', component: AdminTemplateComponent },
  { path: 'bots/:merchantId', component: AdminBotComponent },
  { path: 'merchant-dashboard/:merchantId/:merchantName', component: MerchantDashboardComponent },
  { path: 'social-hub/competition-zone', component: SocialHubMain },
  { path: 'social-hub/competition-zone/:status', component: SocialHubMain },
  {path: 'social-hub/competition-zone/:status/:competitionUUID/:result', component: CompetitionInfo},
  {path: 'social-hub/competition-zone/entry/:status/:competitionUUID/:result', component: CompetitionEntry},
  {path: 'social-hub/competition-zone/competition/create-competition/:competitionUUID/edit', component : CreateCompetition, canDeactivate: [UnsavedChangesGuard],},
  {path: 'social-hub/post-hub', component: PostHub},
  {path: 'social-hub/create-post/:postId', component: CreatePost},
  {path: 'social-hub/post-detail/:postId', component: PostDetail},
  {path: 'banners/list-banner', component: ListBanner},
  {path: 'banners/create-banner/:bannerId', component: CreateBanner},

  {path: 'social-hub/create-post/:postId/:isSchedule', component: CreatePost},
  {path: 'social-hub/post-detail/:postId/:isSchedule', component: PostDetail},
  {path: 'social-hub/create-post/:postId', component: CreatePost},
  {path: 'social-hub/post-detail/:postId', component: PostDetail},
  {path: 'banners/list-banner', component: ListBanner},
  {path: 'banners/create-banner', component: CreateBanner},
  {path: 'banner-hub/banner-list', component: BannerList},
  {path: 'banner-hub/create-banner', component: BannerCreate}


];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    PipeModule
  ],
  exports: [
    RouterModule,
    PipeModule
  ]
})
export class AdminRoutingModule { }
